import { put, take, call } from 'redux-saga/effects';
import {
  updateEntityBackupSettingDescription,
  updateEntityBackupSettingDescriptionError,
} from '../../reducers/entityBackupSettingsSlice';
import withLoading from '../../sagas/loadingSaga';

export default function* updateEntityBackupSettingsSaga(api) {
  while (true) {
    const updateEntityBackupSettingsAction = yield take(
      updateEntityBackupSettingDescription.type,
    );
    yield call(withLoading, function* () {
      const {
        entityId,
        correlationId,
        updatedDescription,
        tableItemType,
        filename,
      } = updateEntityBackupSettingsAction.payload;

      yield call(
        updateEntityBackupSettingsDescription,
        api,
        entityId,
        correlationId,
        updatedDescription,
        tableItemType,
        filename,
      );
    });
  }
}

function* updateEntityBackupSettingsDescription(
  api,
  entityId,
  correlationId,
  updatedDescription,
  tableItemType,
  filename,
) {
  try {
    yield call(
      api.updateEntityBackupDescription,
      entityId,
      correlationId,
      filename,
      updatedDescription,
      tableItemType,
    );
  } catch (error) {
    yield put(updateEntityBackupSettingDescriptionError(error));
  }
}
